
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
// import axios from "axios";
import apiClient from "../utils/apiClient";
import { SERVER_BASE } from "../config/server";
import Swal from "sweetalert2";
import Select from 'react-select';
import { tyreOptions, vehicleOptions } from './masterList';
import { faChevronCircleLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const VehicleMaster = () => {
    const [formData, setFormData] = useState({
        vehicleType: "",
        vehicleNo: "",
        modal: '',
        chassisNo: "",
        engineNo: "",
        insuranceCompany: "",
        policyNo: "",
        issueDate: "",
        endDate: "",
        unladenWeight: "",
        capacity: "",
        bodyType: "",
        tyreType: "",
        height: "",
        weight: "",
        length: "",
        nature: "Asset / Capital",
        fitnessCertificateNo: "",
        fitnessCertificateEndDate: "",
        createdBy: localStorage.getItem('sid'),
        remarks: ""
    });
    const token = localStorage.getItem("token");
    const code = localStorage.getItem("code");
    const sewadarId = localStorage.getItem("sewadarId");
    const navigate = useNavigate();
    const location = useLocation();
    const [rowData, setRowData] = useState(null);
    const { row } = location.state || {};
    useEffect(() => {
        if (row) {
            setRowData(row);
        }
    }, [row]);

    useEffect(() => {
        if (!rowData) return;
        setFormData(prevState => ({
            ...prevState,
            vehicleType: rowData?.vehicleType || '',
            vehicleNo: rowData?.vehicleNo || '',
            chassisNo: rowData?.chassisNo || '',
            engineNo: rowData?.engineNo || '',
            insuranceCompany: rowData?.insuranceCompany || '',
            policyNo: rowData?.policyNo || '',
            issueDate: rowData?.issueDate || '',
            endDate: rowData?.endDate || '',
            unladenWeight: rowData?.unladenWeight || '',
            capacity: rowData?.capacity || '',
            bodyType: rowData?.bodyType || '',
            tyreType: rowData?.tyreType || '',
            height: rowData?.height || '',
            length: rowData?.length || '',
            modal: rowData?.modal || '',
            fitnessCertificateNo: rowData?.fitnessCertificateNo || '',
            fitnessCertificateEndDate: rowData?.fitnessCertificateEndDate || '',
            remarks: rowData?.remarks
        }));
    }, [rowData]);
    const handleChange = (e) => {
        setFormData((prev) => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };


    const handleSubmit = async () => {
        if (!formData?.vehicleNo) {
            Swal.fire({
                icon: 'error',
                text: formData.vehicleType === "Other"
                    ? 'Please enter Vehicle Description'
                    : 'Please enter Vehicle Number',
                toast: true,
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
            return;
        }        
        const payload = {
            vehicleType: formData?.vehicleType || '',
            vehicleNo: formData?.vehicleNo || '',
            chassisNo: formData?.chassisNo || '',
            engineNo: formData?.engineNo || '',
            insuranceCompany: formData?.insuranceCompany || '',
            policyNo: formData?.policyNo || '',
            issueDate: formData?.issueDate || '',
            endDate: formData?.endDate || '',
            unladenWeight: formData?.unladenWeight || '',
            capacity: formData?.capacity || '',
            bodyType: formData?.bodyType || '',
            tyreType: formData?.tyreType || '',
            height: formData?.height || '',
            length: formData?.length || '',
            modal: formData?.modal || '',
            fitnessCertificateNo: formData?.fitnessCertificateNo || '',
            fitnessCertificateEndDate: formData?.fitnessCertificateEndDate || '',
            nature: formData?.nature,
            createdBy: sewadarId,
            code
        };

        let response;
        try {

            if (rowData?.id) {
                // If rowData exists, update the vehicle details
                response = await apiClient.put(`${SERVER_BASE}/updateVehicleDetails/${rowData.id}`, payload);
            } else {
                // If rowData does not exist, create a new entry
                response = await apiClient.post(`${SERVER_BASE}/saveVehicleDetails`, payload);
            }
            Swal.fire({
                toast: true,
                position: 'top-end',
                icon: 'success',
                title: response.data.message,
                showConfirmButton: false,
                timer: 2000
            }).then(() => {
                navigate('../VehicleMasterList')
            });

        } catch (error) {
            Swal.fire({
                icon: 'error',
                text: error?.response?.data?.message || 'An error occurred while saving the Sewadar.',
                toast: true,
                position: 'top-end',
                timer: 3000,
                showConfirmButton: false,
            });
            console.error("Error submitting form", error);
        }
    };


    return (
        <div className="formcontainer mt-5">
            <div className="d-flex align-items-end mb-3">
                <button
                    className="btn btn-secondary btn-sm me-3"
                    onClick={() => navigate("../VehicleMasterList")}
                >
                    <FontAwesomeIcon icon={faChevronCircleLeft} /> Back
                </button>
                <h5>{row ? "Edit Vehicle" : "Vehicle Master"}</h5>
            </div>
            <div className="row">
                <div className="col-md-3">
                    <label className="form-label">Nature</label>
                    <input type="text" name="nature" className="form-control" readOnly value={formData?.nature} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Vehicle Type</label>
                    <Select
                        options={vehicleOptions}
                        onChange={(selectedOption) =>
                            setFormData({ ...formData, vehicleType: selectedOption.value })
                        }
                        className="basic-single"
                        classNamePrefix="select"
                        value={vehicleOptions.find(option => option.value == formData?.vehicleType) || null}
                    />
                </div>
                <div className="col-md-3">
                    <label className="form-label">
                        {formData.vehicleType === "Other" ? "Vehicle Description" : "Vehicle No"}
                    </label>
                    <input type="text" name="vehicleNo" className="form-control" onChange={handleChange} value={formData?.vehicleNo} required />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Brand & Modal</label>
                    <input type="text" name="modal" className="form-control" onChange={handleChange} value={formData?.modal} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Chassis No</label>
                    <input type="text" name="chassisNo" className="form-control" onChange={handleChange} value={formData?.chassisNo} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Engine No</label>
                    <input type="text" name="engineNo" className="form-control" onChange={handleChange} value={formData?.engineNo} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Insurance Company</label>
                    <input type="text" name="insuranceCompany" className="form-control" onChange={handleChange} value={formData?.insuranceCompany} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Policy No</label>
                    <input type="text" name="policyNo" className="form-control" onChange={handleChange} value={formData?.policyNo} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Issue Date</label>
                    <input type="date" name="issueDate" className="form-control" onChange={handleChange} value={formData.issueDate} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">End Date</label>
                    <input type="date" name="endDate" className="form-control" onChange={handleChange} value={formData?.endDate} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Fitness Certificate No</label>
                    <input type="text" name="fitnessCertificateNo" className="form-control" onChange={handleChange} value={formData?.fitnessCertificateNo} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Fitness Certificate End Date</label>
                    <input type="date" name="fitnessCertificateEndDate" className="form-control" onChange={handleChange} value={formData.fitnessCertificateEndDate} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Unladen Weight (ton)</label>
                    <input type="number" name="unladenWeight" className="form-control" onChange={handleChange} value={formData?.unladenWeight} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Capacity (ton)</label>
                    <input type="number" name="capacity" className="form-control" onChange={handleChange} value={formData?.capacity} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Body Type</label>
                    <input type="text" name="bodyType" className="form-control" onChange={handleChange} value={formData?.bodyType} />
                </div>
                {formData.vehicleType == 'Truck'
                    ? <div className="col-md-3">
                        <label className="form-label">Tyre Type</label>
                        <Select
                            options={tyreOptions}
                            placeholder="Select Tyre Type"
                            onChange={(selectedOption) =>
                                setFormData({ ...formData, tyreType: selectedOption.value })
                            }
                            className="basic-single"
                            classNamePrefix="select"
                            value={tyreOptions.find(option => option.value == formData?.tyreType) || null}
                        />
                    </div> : null}
                <div className="col-md-3">
                    <label className="form-label">Height</label>
                    <input type="number" name="height" className="form-control" onChange={handleChange} value={formData?.height} />
                </div>
                <div className="col-md-3">
                    <label className="form-label">Length</label>
                    <input type="number" name="length" className="form-control" onChange={handleChange} value={formData?.length} />
                </div>
                <div className="col-md-6">
                    <label className="form-label">Remarks</label>
                    <input type="text" name="remarks" className="form-control" onChange={handleChange} value={formData?.remarks} />
                </div>
            </div>

            <button className="btn btn-success mt-2" onClick={handleSubmit}>Submit</button>


        </div>
    );
};

export default VehicleMaster;
